import React from "react";
import talance from '../Photo/Experience/talance.png'
import pttep from '../Photo/Experience/pttep.jpg'
import styled from 'styled-components'

const Mfec = () => (
  <StyledDiv className="mfec container mt-5">
    <section className="dark-grey-text">
      <h2 className="text-center font-weight-bold mb-4 pb-2">MFEC</h2>
      <p className="text-center mx-auto w-responsive mb-5">
        MFEC Public Company Limited (PCL) established in 1997, positioned as a premier IT service provider specializing in network computing and e-business, serving mainly large enterprise customers and industry leaders in both government and private sectors. Our services range from IT consulting, custom design and development, training and after sales services of the solution sets including hardware & software infrastructures, network equipment and services, software package customization & enhancement, and custom software development. Services are tailored to specific user requirements for their unique business needs.
      </p>
      <div className="idca row align-items-center">
        <div className="col-lg-5">
          <div className="view overlay rounded z-depth-2 mb-lg-0 mb-4">
            <img className="img-fluid" src={pttep} alt="Sample image" />
            <a>
              <div className="mask rgba-white-slight"></div>
            </a>
          </div>
        </div>
        <div className="col-lg-7">
          <a href="#!" className="green-text">
            <h6 className="font-weight-bold mb-3">
              <i className="fas fa-business-time pr-2"></i>Full-Time Job (Front-end) (VueJs)
            </h6>
          </a>
          {/* Init warpper */}
          <h4 className="font-weight-bold mb-3">
            <strong>IDCA (PTTEP) </strong>
            <span className="sub-detail">(Web application that display calculations of gas and oil
              for each well and zone)</span>
          </h4>
          <div className="pttep">
            <h6>Company's description</h6>
            <p className="description">
              PTTEP (Client) is a national petroleum exploration and production company dedicating to provide a sustainable petroleum supply to Thailand
              and the countries they operate as well to bring in foreign exchange earnings to our country.
            </p>
          </div>
          <p>
            1. Implement and improve UX/UI that display calculation of gas (Conventional and PZ methods) and oil using VueJs and ChartJs
            <br />
            2. Implement and improve functions and unit-test using Jest
            <br />
            3. Work with developer team using scrum methodology
          </p>
          <p>
            <a>
              <strong>Duration: </strong>
            </a>{" "}
            <div className="orange-text">11/2021 to Current</div>{" "}
          </p>
        </div>
      </div>



      <div className="talance row align-items-center">
        <div className="col-lg-5">
          <div className="view overlay rounded z-depth-2 mb-lg-0 mb-4">
            <img className="img-fluid" src={talance} alt="Sample image" />
            <a>
              <div className="mask rgba-white-slight"></div>
            </a>
          </div>
        </div>
        <div className="col-lg-7">
          <a href="#!" className="green-text">
            <h6 className="font-weight-bold mb-3">
              <i className="fas fa-business-time pr-2"></i>Full-Time Job (Front-end) (ReactJs)
            </h6>
          </a>
          {/* Init warpper */}
          <h4 className="font-weight-bold mb-3">
            <strong>Talance </strong>
            <span className="sub-detail">(Web application for matching between tech companies and freelancers) </span>
          </h4>
          <div className="pttep">
            <h6>Project's description</h6>
            <p className="description">
              Talance is a platform connecting between IT workforce and the company that wants to hire IT outsourcing.
            </p>
          </div>
          <p>
            1. Implemented Onboarding page for a freelancer to fill in their information which are skills, average working time, and job details
            <br /> 2. Implemented job lists page (To display all jobs detail base on a user’s skills)
            <br />     3. Implemented the user profile page that contains several sections which are portfolio, avatar, project experience, skills, and working info (freelancer can edit profile, and the organization can view their profile only)
            <br /> 4. Implemented functions to handle responses from the back-end
            <br />  5. Implemented functions to handle web application behavior
            <br />   6. Implemented unit-test for functions by using jest
            <br /> 7. Implemented responsive design for all devices
            <br />  8. Worked with developer team and clients using scrum methodology

          </p>
          <p>
            <a>
              <strong>Duration: </strong>
            </a>{" "}
            <div className="orange-text">02/2021 to 10/2021</div>{" "}
          </p>
          {/* end warpper */}

        </div>
      </div>

      <hr class="my-5" />
    </section>
  </StyledDiv>
);

const StyledDiv = styled.div`
  &.mfec{
    span.sub-detail{
      color: gray;
      font-size: 12px;
    }
    .pttep{
      /* color:blue; */
      h6{

        font-weight: bold;
      }
      
    }
    .talance{
      margin-top: 32px;
    }

  }
`

export default Mfec;
